import React from "react";
import { cls } from "app/utils";
import styles from "./styles.module.scss";
import { NotificationModel } from "app/models/NotificationModel";
import UserAvatar from "app/components/UserAvatar";
import { getNotificationLabel } from "../getNotificationLabels";
import { notificationDate } from "app/utils/notificationDate";
import { NotificationsModel } from "app/models";

interface Props {
  notification: NotificationModel;
  onNotificationClick?: (notification: NotificationModel) => void;
  className?: string;
}

const formatLocation = (notification: NotificationsModel): string => {
  const { meta } = notification;

  if (meta.teamGroup) {
    const team = meta.team || {};
    const teamName = team.teamName || team.name;
    const groupName = meta.teamGroup.teamGroupName || meta.teamGroup.name;
    return ` • ${teamName} / ${groupName}`;
  }

  if (meta.team) {
    const teamName = meta.team.teamName || meta.team.name;
    return ` • ${teamName} / General`;
  }

  if (meta.space) {
    return ` • ${meta.space.athleteName} / ${meta.space.sport}`;
  }

  return "";
};

const NotificationAttachment: React.FC<{ notification: NotificationModel }> = ({
  notification,
}) => {
  const { post } = notification.meta;

  if (!post || post.type === "note") {
    return null;
  }

  if (post.type === "audio") {
    return (
      <i
        className={cls(
          "ico ico-microphone",
          styles.notification_attachment_icon,
        )}
      />
    );
  }

  if (post.type === "gallery") {
    return (
      <i className={cls("ico ico-gallery-post", styles.gallery_post_icon)} />
    );
  }

  return (
    <img
      src={post.mediaThumbnail}
      alt="post image"
      className={styles.notification_image}
    />
  );
};

const SingleNotification = ({
  notification,
  onNotificationClick,
  className,
}: Props) => {
  const { initiator, createdAt, read } = notification;

  const handleClick = () => {
    onNotificationClick?.(notification);
  };

  return (
    <div
      className={cls(styles.notification, className, {
        [styles.unread]: !read,
      })}
      onClick={handleClick}
    >
      <div className={styles.left_side}>
        <UserAvatar
          altName="user avatar"
          sizeHeight={44}
          sizeWidth={44}
          className={styles.avatar}
          srcName={initiator?.avatarUrl}
          userName={initiator?.name}
        />
        <div className={styles.content_wrapper}>
          <span className={styles.content_message}>
            <p className={styles.text_message}>
              {getNotificationLabel(notification)}
            </p>
          </span>
          <span className={styles.content_info}>
            <b>
              {createdAt && notificationDate(createdAt)}
              {formatLocation(notification)}
            </b>
          </span>
        </div>
      </div>
      <NotificationAttachment notification={notification} />
    </div>
  );
};

export default SingleNotification;
